export const adobeStyle = {
    computer: {
        page: {
            marginTop: "3%"
        },
        headerContainer: {
            margin: "0 auto",
            width: "60%"
        },
        header: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
            marginBottom: "3%"
        },
        subheader: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
            marginBottom: "1%"
        },
        container: {
            backgroundColor: "rgb(180, 74, 70)",
            width: "60%",
            margin: "0 auto",
            paddingTop: "2%",
            paddingBottom: "2%",
            marginBottom: "9.5%"
        }
    },
    tablet: {
        page: {
            marginTop: "3%"
        },
        headerContainer: {
            margin: "0 auto",
            width: "60%"
        },
        header: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
            marginBottom: "3%"
        },
        subheader: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
            marginBottom: "1%"
        },
        container: {
            backgroundColor: "rgb(180, 74, 70)",
            width: "60%",
            margin: "0 auto",
            paddingTop: "2%",
            paddingBottom: "2%"
        },
        photoshop: {
            margin: "0 auto",
            marginLeft: "32.5%"
        },
        illustrator: {
            margin: "0 auto",
            marginLeft: "32.5%"
        },
        indesign: {
            margin: "0 auto",
            marginLeft: "32.5%"
        },
        premiere: {
            margin: "0 auto"
        }
    },
    mobile: {
        page: {
            marginTop: "3%"
        },
        headerContainer: {
            margin: "0 auto",
            width: "60%"
        },
        header: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
            marginBottom: "3%"
        },
        subheader: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
            marginBottom: "1%"
        },
        container: {
            backgroundColor: "rgb(180, 74, 70)",
            width: "60%",
            margin: "0 auto",
            paddingTop: "2%",
            paddingBottom: "2%",
            paddingRight: "20%",
            paddingLefT: "20%"
        },
        photoshop: {
            margin: "0 auto",
            marginLeft: "29%"
        },
        illustrator: {
            margin: "0 auto",
            marginLeft: "29%"
        },
        indesign: {
            margin: "0 auto",
            marginLeft: "29%"
        },
        premiere: {
            margin: "0 auto",
            marginLeft: "29%"
        }
    }
};